var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 248 413",
    width: 248,
    height: 413,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1008-2506h1366v3181h-1366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1008-27h1366v414.09h-1366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.64 31.93h161.03v161.02h-161.03z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m124.2 412.4c-0.9 0-1.7-0.5-2.1-1.3l-109.9-233.5c-7.9-16.7-11.9-34.6-11.9-53.1 0-68.3 55.6-123.8 123.8-123.8 68.3 0 123.9 55.5 123.9 123.8 0 18.3-3.9 35.9-11.6 52.3q0 0.4-0.2 0.8l-109.9 233.5c-0.4 0.8-1.2 1.3-2.1 1.3zm-0.1-407.1c-65.7 0-119.2 53.5-119.2 119.2 0 17.9 3.9 35 11.5 51.1l0.3 0.6 107.5 228.5 107.5-228.4q0.1-0.4 0.2-0.7c7.6-16.1 11.5-33.2 11.5-51.1 0-65.7-53.5-119.2-119.3-119.2z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m204.7 112.4c0 44.5-36.1 80.6-80.6 80.6-44.4 0-80.5-36.1-80.5-80.6 0-44.4 36.1-80.5 80.5-80.5 44.5 0 80.6 36.1 80.6 80.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.726765769f611e2875b5e8bece13b67b.svg";
export { ForwardRef as ReactComponent };